import { connect } from 'react-redux';
import { MoreOptions } from 'components/common';
import { EditorBlockCustomControls } from '.';

const EditorBlockCustomSettings = connect((state) => ({
  messages: state.messages
}))(({ children, messages }) => (
  <EditorBlockCustomControls>
    <MoreOptions
      align="left"
      category="light"
      dropdownStyle={{ top: 'auto', bottom: 35 }}
      icon="cog"
      label={messages.commonSettings}
      styleContentButtons={false}
      tooltip={messages.commonSettings}
    >
      <div className="content" data-keep-open={true}>
        {children}

        <style jsx>{`
          .content {
            padding: 5px 12px;
            width: 240px;
          }
        `}</style>
      </div>
    </MoreOptions>
  </EditorBlockCustomControls>
));

export default EditorBlockCustomSettings;
